import React, { useMemo, useCallback } from 'react';
import { withLocalize } from 'react-localize-redux';
import _ from 'lodash';
import { Text } from '../Text';
import { useLocalize } from '../../../hooks';

var FieldRequirementContent = function FieldRequirementContent(_ref) {
  var type = _ref.type,
      min = _ref.min,
      max = _ref.max,
      valid = _ref.valid,
      data = _ref.data,
      translate = _ref.translate,
      color = _ref.color;

  var _useLocalize = useLocalize(),
      getTranslationId = _useLocalize.getTranslationId;

  var formatNumberAsTranslatedDigit = useCallback(function (value) {
    if (value && value < 10) {
      var translatedDigit = translate(getTranslationId({
        id: "digits.".concat(value),
        type: 'page'
      }));

      if (_.isString(translatedDigit)) {
        return translatedDigit;
      }
    }

    return "".concat(value);
  }, [translate, getTranslationId]);
  var fieldLabel = useMemo(function () {
    switch (type) {
      case 'length-min':
      case 'length-range':
      case 'special-min':
      case 'special-acceptable':
        return 'characters';

      case 'lower-min':
      case 'upper-min':
        return 'letters';

      case 'digit-min':
        return 'digits';

      case 'contains-username':
      case 'equals-email':
      case 'contains-first-name':
      case 'contains-forbidden-keywords':
      case 'contains-last-name':
      case 'repeated-password':
        return type;
    }
  }, [type]);
  var typeLabel = useMemo(function () {
    var fieldTypeId = "".concat(fieldLabel, "-label.").concat(!min || min !== 1 ? 'plural' : 'singular');
    var translatedLabel = translate(getTranslationId({
      id: fieldTypeId,
      type: 'page'
    }));
    return _.isString(translatedLabel) ? translatedLabel : fieldLabel;
  }, [fieldLabel, min, translate, getTranslationId]);
  var textData = useMemo(function () {
    return Object.assign({}, data, {
      min: max ? min : formatNumberAsTranslatedDigit(min),
      max: max,
      label: typeLabel
    });
  }, [data, min, max, typeLabel, formatNumberAsTranslatedDigit]);

  if (!min) {
    return null;
  }

  return React.createElement("li", {
    style: {
      color: color ? color : 'initial'
    }
  }, !_.isUndefined(valid) && React.createElement(React.Fragment, null, React.createElement("i", {
    className: "fa ".concat(valid ? "fa-check ".concat(color) : 'fa-exclamation-circle error')
  }), ' '), React.createElement(Text, {
    id: "fieldRequirements.".concat(type),
    page: "secure",
    data: textData
  }));
};

export var FieldRequirement = withLocalize(FieldRequirementContent);